////////LIBRARY/////////
import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom'
import { map, indexOf, find, cloneDeep, filter, isEmpty, isUndefined, isNull } from 'lodash'
import { Transition } from 'react-transition-group'
///////COMPONENTS///////
import MenuLink from './MenuLink'
import { languagesActionCreators, loginActionCreators } from '../../../store/actions'
import { uriList } from '../../../routings/settings/RouteList'
import UserAuthorizationLayout from '../../../components/UserAuthorizationLayout'
import userPrivileges from '../../../constants/PrivilegesList'
/////////ASSETS/////////
import MyAccount from '../../../assets/icones/menu/friends.svg'
import Logout from '../../../assets/icones/menu/logout.svg'
import MenuLogoIcon from '../../../assets/icones/menu/burger-menu-icon.svg'
import MenuCarouselBottomIcon from '../../../assets/icones/menu/menu-dropdown.svg'
import Home from '../../../assets/icones/menu/home.svg'
import Articles from '../../../assets/icones/menu/article.svg'
import Prices from '../../../assets/icones/menu/prices.svg'
import Stocks from '../../../assets/icones/menu/stocks.svg'
import Sales from '../../../assets/icones/menu/sales.svg'
import Manage from '../../../assets/icones/menu/manage.svg'
import Config from '../../../assets/icones/menu/config.svg'
import Kiosks from '../../../assets/icones/menu/kiosks.svg'

/////////STYLED/////////
const MenuBottomPart = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: auto;
	margin-bottom: 30px;
	margin-top: 30px;
`
const MenuBottomLinks = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 30px;
`
const MenuBottomLink = styled.div``

const FlagLinkWrapper = styled.div`
	display: flex;
	flex-direction: row;
	overflow-x: ${(props) => (props.toggled ? 'auto' : 'hidden')};
	grid-column-gap: 5px;
	justify-content: start;
	&::-webkit-scrollbar {
		height: 6px;
	}
	&::-webkit-scrollbar-thumb {
		background: #4d4f5c;
		border-radius: 3px;
	}
	&::-webkit-scrollbar-thumb:active {
		background: rgba(77, 79, 92, 0.7);
	}
	/* scrollbar styling standard version */
	& {
		scrollbar-color: #4d4f5c transparent;
	}
`
const FlagLink = styled.div`
	margin: 0px 11px;
`
const MenuCarousel = styled.div`
	height: calc(100% - 316px);
	overflow-y: auto;
	overflow-x: hidden;
	-ms-overflow-style: none;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		width: 0px;
		background: transparent;
		display: none;
	}
	&::-webkit-scrollbar-thumb {
		background: #ff0000;
	}
`
const MenuCarouselBottom = styled.div`
	height: 50px;
	background-color: #242424;
	background-position: center;
	background-repeat: no-repeat;
	background-image: url('${MenuCarouselBottomIcon}');
`
const MenuWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: fixed;
	top: 124px;
	z-index: 52;
	width: ${({ menuTransition }) => {
		switch (menuTransition) {
			case 'entering':
				return '50px'
			case 'entered':
				return '200px'
			case 'exiting':
				return '200px'
			case 'exited':
				return '50px'
			default:
				return '50px'
		}
	}};
	height: calc(100vh - 124px);
	background-color: ${(props) => props.theme.colors.menu.wrapper};
	overflow-x: hidden;
	transition: all 0.1s;
`
const MenuLogo = styled.div`
	height: 50px;
	background-color: #242424;
	background-image: ${(props) => (props.toggled ? 'none' : `url(${MenuLogoIcon})`)};
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	position: relative;
	box-shadow: 0px 10px 6px #26262659;
`
const MenuToggledIcon = styled.div`
	border-left: 8px solid ${(props) => props.theme.colors.white};
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	position: absolute;
	right: ${(props) => (props.toggled ? 18 : -18)}px;
	transform: translateY(-50%) rotate(180deg);
	transition: 0.1s;
	top: 50%;
`
const FlagImg = styled.img`
	max-width: 26px;
	height: 17px;
	cursor: pointer;
	box-sizing: content-box;
	border: ${(props) => (props.selectedLanguage ? `1px solid ${props.theme.colors.primary}` : 'none')};
	border-radius: 3px;
`
/////////STYLED/////////

const Menu = () => {
	const [currentMenu, setCurrentMenu] = useState([])

	let history = useHistory()
	// menu behaviour
	const [toggled, setToggled] = useState(false)
	const [toggledAll, setToggledAll] = useState(false)
	const [toggledNested, setToggledNested] = useState([])
	const [currentLanguagesList, setCurrentLanguagesList] = useState([])

	const refFlagList = useRef()

	const { languagesList, user, translations, userMenu, selectedLanguage } = useSelector(
		(state) => ({
			user: state.user,
			languagesList: state.languages.items,
			translations: state.languages.translations,
			userMenu: state.user.identity.menus,
			selectedLanguage: state.languages.selectedLanguage,
		}),
		shallowEqual
	)
	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())
	const actionsLogin = bindActionCreators(loginActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSetToggledNested = (id) => {
		const nestedList = cloneDeep(toggledNested)

		nestedList.forEach((elem) => {
			if (elem.id === id) {
				elem.toggle = !elem.toggle
			} else if (toggledAll) {
				setToggledAll(!toggledAll)
			} else {
				elem.toggle = false
			}
		})
		setToggledNested(nestedList)
	}

	/**
	 * call to change user languages
	 * @param   {string}        idLanguage
	 * @param   {string}        scope for language ( e.g 'public' || 'private' )
	 */
	const changeLanguageHandler = (idLanguage, scope) => {
		if (scope === 'private') {
			actionsLanguages.getTranslationByLanguages(idLanguage)
		} else {
			actionsLanguages.getTranslationPublicPage(idLanguage)
		}
	} // end function

	const getLogout = () => {
		actionsLogin.getLogout()
	}

	const handleMyAccount = () => {
		history.push(`${uriList.myAccount}${uriList.myAccountEdit}`)
	}

	const handlePreferences = () => {
		history.push(`${uriList.preferences}${uriList.userPreferencesEdit}`)
	}

	const wrapperRef = useRef(null)

	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setToggled(false)
				}
			}

			// Bind the event listener
			document.addEventListener('mousedown', handleClickOutside)

			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('mousedown', handleClickOutside)
			}
		}, [ref])
	}

	useOutsideAlerter(wrapperRef)

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (toggled) return

		handleSetToggledNested('reset')
	}, [toggled])

	useEffect(() => {
		// Put language of user in first position
		let f = find(languagesList, (o) => o?.id === user.identity.preferedLanguage.id)
		let ind = indexOf(languagesList, f)
		let cutOut = languagesList.splice(ind, 1)[0]
		languagesList.splice(0, 0, cutOut)
	}, [languagesList])

	const configMenu = [
		{
			id: 1,
			title: translations['ref__menu_privilege_dashboard'],
			link: uriList.home,
			icon: Home,
			nested: false,
			subMenus: [],
		},
		{
			id: 2,
			title: translations['ref__menu_privilege_items'],
			icon: Articles,
			nested: true,
			subMenus: [
				{
					title: translations['ref__menu_privilege_itemRef'],
					link: `${uriList.distributionItems}${uriList.distributionGroupRepo}`,
					// icon:,
					requiredRight: userPrivileges.view[0],
				},
				{
					title: translations['page__itemCatalog__tab__distributor_link'],
					link: `${uriList.catalog}${uriList.addItemCatalog}`,
					// icon:,
					requiredRight: userPrivileges.view[31],
				},
				{
					title: translations['menu__submenu_itemCatalog_kiosk'],
					// Direct link if separated breadcrumb
					link: `${uriList.itemCatalog}`,
					//link: `${uriList.distributionItems}${uriList.itemCatalog}`,
					requiredRight: userPrivileges.view[37],
				},
			],
		},
		{
			id: 3,
			title: translations['ref__menu_privilege_prices'],
			icon: Prices,
			nested: true,
			subMenus: [
				{
					title: translations['ref__menu_privilege_pricePerKiosk'],
					link: `${uriList.prices}${uriList.kioskPricesManager}`,
					// icon:,
					requiredRight: userPrivileges.view[2],
				},
				{
					title: translations['ref__menu_privilege_priceUpdate'],
					link: `${uriList.prices}${uriList.scheduledPricesManager}`,
					// icon:,
					requiredRight: userPrivileges.view[4],
				},
				{
					title: translations['ref__menu_privilege_promotion'],
					link: `${uriList.prices}${uriList.scheduledPromoManager}`,
					// icon:,
					requiredRight: userPrivileges.view[5],
				},
			],
		},
		{
			id: 4,
			title: translations['ref__menu_privilege_stocks'],
			icon: Stocks,
			nested: true,
			subMenus: [
				{
					title: translations['ref__menu_privilege_stockInfo'],
					link: `${uriList.recapStock}`,
					// icon:,
					requiredRight: userPrivileges.view[15],
				},
			],
		},
		{
			id: 5,
			title: translations['ref__menu_privilege_sales'],
			icon: Sales,
			nested: true,
			subMenus: [
				{
					title: translations['ref__menu_privilege_salesByKiosk'],
					link: `${uriList.sales}${uriList.salesHistory}`,
					// icon:,
					requiredRight: userPrivileges.view[6],
				},
				{
					title: translations['ref__menu_privilege_salesByCode'],
					link: `${uriList.sales}${uriList.salesHistoryByCodes}`,
					// icon:,
					requiredRight: userPrivileges.view[10],
				},
				{
					title: translations['ref__menu_privilege_consignment'],
					link: `${uriList.sales}${uriList.consignation}`,
					// icon:,
					requiredRight: userPrivileges.view[11],
				},
				{
					title: translations['ref__menu_privilege_marketing'],
					link: `${uriList.sales}${uriList.marketingManager}`,
					// icon:,
					requiredRight: userPrivileges.view[35],
				},
				{
					title: translations['ref__menu_privilege_paymentCollection'],
					link: `${uriList.sales}${uriList.telecollectManager}`,
					// icon:,
					requiredRight: userPrivileges.view[13],
				},
				{
					title: translations['ref__menu_privilege_codeGeneration'],
					url: 'https://recette-vm-manage.we-deal.fr/',
					// icon:,
					requiredRight: userPrivileges.view[28],
				},
			],
		},
		{
			id: 6,
			title: translations['ref__menu_privilege_management'],
			icon: Manage,
			nested: true,
			subMenus: [
				{
					title: translations['ref__menu_privilege_userManagement'],
					link: `${uriList.users}${uriList.usersManager}`,
					// icon:,
					requiredRight: userPrivileges.view[16],
				},
				{
					title: translations['ref__menu_privilege_roleManagement'],
					link: `${uriList.users}${uriList.rolesManager}`,
					// icon:,
					requiredRight: userPrivileges.view[17],
				},
				{
					title: translations['ref__menu_privilege_tagManagement'],
					link: `${uriList.tags}${uriList.tagsUsersManager}`,
					// icon:,
					requiredRight: userPrivileges.view[18],
				},
				{
					title: translations['ref__menu_privilege_rgpd'],
					link: `${uriList.rgpd}`,
					// icon:,
					requiredRight: userPrivileges.view[19],
				},
				{
					title: translations['ref__menu_privilege_logs'],
					link: `${uriList.log}${uriList.logUserManager}`,
					// icon:,
					requiredRight: userPrivileges.view[23],
				},
				{
					title: translations['ref__menu_privilege_companyManagement'],
					link: `${uriList.companies}${uriList.companiesManager}`,
					// icon:,
					requiredRight: userPrivileges.view[20],
				},
				{
					title: translations['page__languageManagement__tab'],
					link: `${uriList.languages}${uriList.languagesManager}`,
					// icon:,
					requiredRight: userPrivileges.view[21],
				},
			],
		},
		{
			id: 7,
			title: translations['ref__menu_privilege_kiosk'],
			icon: Kiosks,
			nested: true,
			subMenus: [
				{
					title: translations['page__initKiosk__kioskCreation_tab'],
					link: `${uriList.initKiosks}${uriList.initKioskBusinessManager}`,
					requiredRight: userPrivileges.view[32],
				},
				{
					title: translations['page__initKiosk__kioskCreation_tab'],
					link: `${uriList.initKiosks}${uriList.initKioskCustomerManager}`,
					requiredRight: userPrivileges.view[33],
				},
				{
					title: translations['ref__menu_privilege_initKiosksProduction'],
					link: `${uriList.kiosksInProduction}${uriList.kioskProductionList}`,
					requiredRight: userPrivileges.view[36],
				},
				{
					title: translations['page__kiosk__transactionAnalysis__tab_title'],
					link: `${uriList.salesControl}${uriList.salesControlList}`,
					requiredRight: userPrivileges.view[42],
				},
			],
		},
	]

	useEffect(() => {
		const nestedMenu = filter(configMenu, { nested: true })

		setToggledNested(map(nestedMenu, (elem) => ({ id: elem.id, toggle: false })))
		setCurrentMenu(configMenu)
	}, [])

	// When user infos are loaded, check what is shown to user
	useEffect(() => {
		if (!isEmpty(userMenu) && !isEmpty(translations)) {
			let cur_menu = cloneDeep(configMenu)
			map(cur_menu, (item) => {
				const userMenuItem = find(userMenu, { id: item.id })
				//item.title = translations[userMenuItem.translation]
				if (!isUndefined(userMenuItem)) item.active = userMenuItem.active
			})
			setCurrentMenu(cur_menu)
		}
	}, [userMenu, translations])

	// Ordering language list with default language at first
	// Also ordering alphabetically the list
	useEffect(() => {
		if (!isEmpty(languagesList) && !isNull(selectedLanguage)) {
			let alphaOrder = cloneDeep(languagesList)
			alphaOrder = alphaOrder.sort((a, b) => (a.labelEnglish > b.labelEnglish ? 1 : -1))
			let ord = [find(languagesList, (o) => o?.id === selectedLanguage)]
			alphaOrder.forEach((elem) => {
				if (elem?.id !== selectedLanguage) {
					ord.push(elem)
				}
			})
			setCurrentLanguagesList(ord)
			refFlagList.current.scrollLeft = 0
		}
	}, [languagesList, selectedLanguage])

	// When reducing menu, resetting scroll of flag list
	useEffect(() => {
		if (!toggled && !isUndefined(refFlagList.current)) {
			refFlagList.current.scrollLeft = 0
		}
	}, [toggled])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Transition
			in={toggled}
			timeout={{
				appear: 0,
				enter: 0,
				exit: 0,
			}}
		>
			{(state) => (
				<MenuWrapper menuTransition={state} ref={wrapperRef}>
					<MenuLogo onClick={() => setToggled(!toggled)} toggled={toggled}>
						<MenuToggledIcon toggled={toggled} />
					</MenuLogo>
					<MenuCarousel>
						{map(currentMenu, (elem, id) =>
							elem.active ? (
								elem.nested ? (
									<MenuLink
										key={id}
										menuId={elem.id}
										specActionIcon={() =>
											// Even if toggled, we need to return something.
											// Otherwise, we cannot toggle menu at first click.
											toggled ? null : setToggled(!toggled)
										}
										text={elem.title}
										icon={elem.icon}
										nested={elem.nested}
										canToggle={toggled}
										subMenus={elem.subMenus}
										handleSetToggledNested={handleSetToggledNested}
										toggledNested={find(toggledNested, { id: elem.id }) ?? []}
									/>
								) : (
									<MenuLink
										key={id}
										text={elem.title}
										icon={elem.icon}
										// link={`${uriList.myAccount}`}
										specAction={() => history.push(elem.link)}
										nested={false}
									/>
								)
							) : null
						)}
					</MenuCarousel>
					<MenuCarouselBottom />
					<MenuBottomPart>
						<MenuBottomLinks>
							<UserAuthorizationLayout name={userPrivileges.view[27]}>
								<MenuBottomLink>
									<MenuLink
										text={translations['menu__myAccount']}
										icon={MyAccount}
										// link={`${uriList.myAccount}`}
										specAction={handleMyAccount}
										nested={false}
										noBG
										bgSize={48}
									/>
								</MenuBottomLink>
							</UserAuthorizationLayout>
							{
								<UserAuthorizationLayout name={userPrivileges.view[29]}>
									<MenuBottomLink>
										<MenuLink
											text={translations['menu__mySettings']}
											icon={Config}
											specAction={handlePreferences}
											noBG
											nested={false}
										/>
									</MenuBottomLink>
								</UserAuthorizationLayout>
							}
							<MenuBottomLink>
								<MenuLink
									text={translations['menu__logOut']}
									icon={Logout}
									//onClick={() => getLogout}
									specAction={getLogout}
									nested={false}
									noBG
									bgSize={48}
								/>
							</MenuBottomLink>
						</MenuBottomLinks>
						<FlagLinkWrapper toggled={toggled} ref={refFlagList}>
							{map(currentLanguagesList, (elem, id) => {
								{
									return (
										<FlagLink key={id}>
											{/* No action on first item (the current language) */}
											<FlagImg
												src={`/${elem?.picturePath}`}
												selectedLanguage={selectedLanguage === elem?.id}
												onClick={() =>
													selectedLanguage === elem?.id ? setToggled(!toggled) : changeLanguageHandler(elem?.id, 'private')
												}
												scope="private"
											/>
											{/* <Base64Images
														base64={ elem.picture_path }
														width='26'
														height='17'
														idElem={ elem.id }
														scope='private'
														click={ changeLanguageHandler }
														noAction={ ( id > 0 ) ? false : true }
													/> */}
										</FlagLink>
									)
								}
							})}
						</FlagLinkWrapper>
					</MenuBottomPart>
				</MenuWrapper>
			)}
		</Transition>
	)
}

Menu.propTypes = {}

export default Menu
